import { atom } from 'recoil';

export const navbarState = atom<boolean>({
    key: 'navbar',
    default: false,
});
